"use client";
import { useRouter } from "next/navigation";

import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import AppRoutes from "@/app/constants/routes";
import { useMixPanel } from "@/app/context/mixPanelContext";
import isLoggedIn from "@/app/redirect";
import ToastUtils from "@/app/toast/toast-utils";
import {
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import Link from "next/link";

import ErrorMessage from "@/app/component/error-message";
import { Country, useCountriesQuery } from "@/app/hooks/useCountries";
import CustomButtonV2 from "@/app/versioning/components/v2/CustomButton/CustomButtonV2";
import PreLoginCustomHeader from "@/app/versioning/components/v2/CustomHeader/custom_header";
import { IoIosArrowDown } from "react-icons/io";
import { IoArrowBackSharp, IoCallOutline } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";
import { OTPRegisterPageV2 } from "../../../RegistrationPage/v2/registerComponents/otp-verification/otp-component-register-v2";
import { InputTextBoxV2 } from "./InputTextBoxV2";
import { WebUI } from "./LeftPanel";
import ErrorMessageV2 from "./error-message-v2";
import { MobileSelectNewV2 } from "./mobileinputbox_new_v2";
import { MobileInputBoxV2 } from "@/app/versioning/components/v2/CommonComponents/MobileInputBox";
import NewUserRegistration from "./newUserRegistration";
import Oauth from "./oauth";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import CustomCheckbox from "@/app/versioning/components/v2/CommonComponents/CustomCheckbox";
export interface LoginInfo {
  countryCode?: string;
  mobile?: string;
  token?: string;
  email?: string;
  fromWhere: string;
}
export interface CountryCodeType {
  code: string;
  flag: any;
  currency: string;
  name: string;
}

export enum LoginType {
  Mobile,
  Email,
  MobileAndEmail,
}

function LoginWithOTPV2({ placeHolderText, toastType, islogin = true }: any) {
  const context = useAppContext();
  const { trackEvent } = useMixPanel();
  const {
    instances: { apiRepository },
    state: { isMobile, isLoggedIn, user, memberships },
    fetchUserProfile,
  } = context;
  const { config, getImagePath } = useClientConfigProvider();
  const router = useRouter();
  const [otpAuth, setOtpAuth] = useState<string>();
  // fetchUserProfile();
  const { t } = useTranslation();
  const token = UniversalStorageUtils.getItem(
    config?.nativeDataSavingType,
    UniversalStorageConstants.AUTH_TOKEN
  );
  useEffect(() => {
    // const token = UniversalStorageUtils.getItem(
    //   config?.nativeDataSavingType,
    //   UniversalStorageConstants.AUTH_TOKEN
    // );

    if (token && !user?.data?.firstName) {
      console.log("checkingloginashutosh", token);
      router.push(AppRoutes.registerUserDetails);
      return;
    }
    if (token && user?.data?.firstName && !memberships?.data?.length) {
      router.push(AppRoutes.loginLinkMembership);
    }
  }, [user?.data]);

  // const [countryCode, setCountryCode] = useState("");
  // const [countryCodeFlag, setCountryCodeflag] = useState<string>("");
  // const [selectedCountryISO, setSelectedCountryISO] = useState<string>("");

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<Country>();
  const {
    name,
    code: countryCode,
    flag,
    supported,
    currency,
    countryISOCode,
  } = selectedCountry || {};

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOTPComponent, setIsOTPComponent] = useState<boolean>(false);
  const [isUserNameRegistered, setIsUserNameRegistered] =
    useState<boolean>(false);

  const [switchSignInType, setswitchSignInType] = useState<string>("email");
  const [validationSchema, setValidationSchema] = useState<any>(null);
  const [termsChecked, setTermsChecked] = useState(false);

  useEffect(() => {
    if (switchSignInType == "email" && islogin) {
      trackEvent(EventLabels.SL_Login_Email, { screen: "Login" });
      trackEvent(EventLabels.SL_Login_Email_Done, { screen: "Login" });
    }
  }, [switchSignInType, trackEvent]);

  useEffect(() => {
    if (config) {
      if (switchSignInType == "mobile" && config?.login?.fields?.mobile) {
        setValidationSchema(
          Yup.object().shape({
            mobile: Yup.string()
              .required(`${config?.login?.fields?.mobile?.validationText}`)
              .matches(
                config?.login?.fields?.mobile?.validationRegex,
                config?.login?.fields?.mobile?.validationText
              ),
          })
        );
      } else if (switchSignInType == "email" && config?.login?.fields?.email) {
        setValidationSchema(
          Yup.object().shape({
            email: Yup.string()
              .required("Email is a required field")
              .matches(
                config?.login?.fields?.email?.validationRegex,
                config?.login?.fields?.email?.validationText
              ),
          })
        );
      }

      (() => signUpForm.validateForm())();
      signUpForm.setFieldValue(
        switchSignInType == "mobile" ? "email" : "mobile",
        ""
      );
    }
  }, [switchSignInType, config]);

  const handleFormSubmit = (values: any) => {
    setIsLoading(true);
    if (config?.login.checkUserBeforeLogin) {
      apiRepository
        ?.checkUser({
          email: values?.email,
          phone: values?.mobile.toString(),
          countryCode: countryCode?.toString(),
        })
        .then((v) => {
          if (v.data.exists == true) {
            handleLoginFormSubmit(values);
            // SessionStorageUtils.saveToSessionStorage(
            //   StringConstants.PARAM_X_REGION,
            //   v?.data?.region
            // );
          } else if (v.data.exists == false) {
            setIsLoading(false);
            ToastUtils.showErrorToast(v?.data?.message ?? "");
          } else {
            setIsLoading(false);
            ToastUtils.showErrorToast("Something went wrong");
          }
        })
        .catch((e) => {
          setIsLoading(false);
          console.log("login error response", e?.response?.data);
          if (e?.response?.data?.message) {
            ToastUtils.showErrorToast(e?.response?.data?.message);
          } else {
            ToastUtils.showErrorToast("Something went wrong");
          }
        });
    } else {
      handleLoginFormSubmit(values);
    }
  };

  const handleLoginFormSubmit = (values: any) => {
    setIsLoading(true);
    let payload;
    if (switchSignInType == "email") {
      payload = {
        email: values.email,
      };
    } else if (switchSignInType == "mobile") {
      payload = {
        phone: values.mobile.toString(),
        countryCode: countryCode?.toString(),
      };
    }
    apiRepository
      ?.loginRegister({ ...payload })
      .then((v) => {
        let response = v?.data.user;
        console.log("user = ", response, v);
        setOtpAuth(v.headers.authorization);
        // UniversalStorageUtils.setItem(
        //   config?.nativeDataSavingType,
        //   UniversalStorageConstants.AUTH_TOKEN,
        //   v.headers.authorization
        // );
        setIsOTPComponent(true);
      })
      .catch((e) => {
        setIsLoading(false);
        if (e?.response?.data?.message) {
          ToastUtils.showErrorToast(e?.response?.data?.message);
        } else {
          ToastUtils.showErrorToast("Something went wrong");
        }
      });
  };

  // const { data: countriesData } = useCountriesQuery();
  // useEffect(() => {
  //   if (countriesData) {
  //     const countrycode = countriesData?.find((country) => {
  //       return country.code == countryCode;
  //     });
  //     if (countrycode == null) {
  //       setCountryCode(countriesData[0]?.code ?? "");
  //       setCountryCodeflag(countriesData[0]?.flag ?? "");
  //       setSelectedCountryISO(countriesData[0]?.countryISOCode ?? "");
  //     }
  //   }
  // }, [countriesData]);

  const signUpForm = useFormik({
    initialValues: {
      mobile: "",
      email: "",
    },
    isInitialValid: false,
    validationSchema: validationSchema,
    onSubmit: handleFormSubmit,
    enableReinitialize: true,
    validateOnBlur: true,
    validateOnMount: true,
    validateOnChange: true,
  });

  const {
    values,
    handleBlur,
    handleChange,
    submitForm,
    touched,
    errors,
    isValid,
  } = signUpForm;
  const handleDivClick = (handleFormSubmit: any) => {
    handleFormSubmit();
    trackEvent(islogin ? EventLabels.CTA_LOGIN : EventLabels.CTA_Registration, {
      meta:
        switchSignInType == "email" ? "Login with Email" : "Login with Mobile",
      screen: "Login",
    });
  };

  const buttonRef = useRef<HTMLButtonElement>(null);
  const handleKeyDown = (e: any) => {
    console.log(
      Boolean(e.key === "Enter" && buttonRef.current),
      e.key === "Enter"
    );
    if (e.key === "Enter" && buttonRef.current) {
      buttonRef?.current?.click();
    }
  };
  const LoginMethodSelector = () => {
    return (
      <div className="login-method-switcher-container">
        <button
          className={`inactive  ${
            switchSignInType == "mobile" ? "active" : ""
          }`}
          onClick={() => setswitchSignInType("mobile")}
        >
          {t("common.mobile")}
        </button>
        <button
          className={`inactive  ${switchSignInType == "email" ? "active" : ""}`}
          onClick={() => setswitchSignInType("email")}
        >
          {t("profile_info_labels.Email")}
        </button>
      </div>
    );
  };
  console.log("countryCode", countryCode);

  return (
    <WebUI>
      <div className="right-login-desktop-container">
        {/* {isUserNameRegistered ? (
          <NewUserRegistration />
        ) :  */}
        {isOTPComponent ? (
          <div className="form-screen-v2">
            <div className="back_button_prelogin black-only display_desktop">
              <button
                className="back-btn-v2 "
                onClick={() => {
                  router.back();
                }}
              >
                <IoArrowBackSharp size={24} />
              </button>
            </div>
            {config?.preLoginCustomHeader?.isShowCustomHeader && (
              <PreLoginCustomHeader dark showLogo={false} />
            )}

            <OTPRegisterPageV2
              // bearerToken={UniversalStorageUtils.getItem(
              //   config?.nativeDataSavingType,
              //   UniversalStorageConstants.AUTH_TOKEN
              // )}
              bearerToken={otpAuth}
              loginSourceValue={
                switchSignInType == "mobile" ? values.mobile : values.email
              }
              countryCode={countryCode}
              editOnClick={() => {}}
              switchSignInType={
                switchSignInType == "mobile" ? "phone number" : "email address"
              }
              setIsUserNameRegistered={setIsUserNameRegistered}
              isUserNameRegistered={isUserNameRegistered}
            />
          </div>
        ) : (
          <div className="form-screen-v2">
            <div className="overlay-v2 display_mobile">
              <img
                src={
                  isMobile
                    ? getImagePath("v2/login/login_bg_dark_mobile.png")
                    : getImagePath("v2/login/login_bg.webp")
                }
                alt="Logo"
                className="bg-login-v2"
              />
            </div>
            <div className="back_button_prelogin display_desktop">
              <button
                className="back-btn-v2 "
                onClick={() => {
                  if (isOTPComponent) {
                    UniversalStorageUtils.clear(config?.nativeDataSavingType);
                    setIsOTPComponent(false);
                    signUpForm.resetForm();
                    setIsLoading(false);
                  } else {
                    if (!config?.restrictedRoutes?.includes(AppRoutes.landing))
                      router.push(AppRoutes.landing);
                  }
                }}
              >
                <IoArrowBackSharp size={24} />
              </button>
            </div>
            <PreLoginCustomHeader />
            <div className="login-form-container">
              <LoginHeader style={{ textAlign: "start" }} />
              {config?.login?.fields?.email &&
                config?.login?.fields?.mobile &&
                LoginMethodSelector()}
              {switchSignInType == "email" && (
                <div className="email-username-container">
                  <InputTextBoxV2
                    mainClassName={"custom-input-bordered"}
                    hint={placeHolderText}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    handleKeyDown={handleKeyDown}
                    isShowSuffix={true}
                    suffix={<MdOutlineEmail className="icon-eye-v2" />}
                    onBlur={handleBlur}
                    name="email"
                    maxLength={50}
                    value={values.email}
                    placeholder={"Email"}
                    hasError={touched?.email != null && errors?.email != null}
                  />
                  <div style={{ marginTop: "3px" }}>
                    <ErrorMessage
                      message={touched?.email ? errors?.email ?? "" : undefined}
                      touched={touched?.email}
                    />
                  </div>
                </div>
              )}
              {switchSignInType == "mobile" && (
                // <div>
                <MobileInputBoxV2
                  // mainClassName="custom-input-bordered-mobile-blue"
                  // handleChange={handleChange}
                  // formik={signUpForm}
                  // countryCode={countryCode}
                  // countryCodesArr={countriesData}
                  // setCountryCode={setCountryCode}
                  // setCountryCodeFlag={setCountryCodeflag}
                  // setCountryCodeISO={setSelectedCountryISO}
                  // handleKeyDown={handleKeyDown}
                  // hasError={touched?.mobile != null && errors?.mobile != null}
                  // prefix={
                  //   <div style={{ display: "flex", alignItems: "center" }}>
                  //     {countryISOCode && (
                  //       <Image
                  //         src={`https://flagcdn.com/w40/${countryISOCode}.png`}
                  //         width={25}
                  //         height={20}
                  //         alt=""
                  //       />
                  //     )}
                  //     <span className="flag" style={{ fontSize: "15px" }}>
                  //       {countryCode ?? ""}
                  //     </span>
                  //     <IoIosArrowDown />
                  //   </div>
                  // }
                  // isShowPrefix={true}
                  // onPrefixClick={() => {
                  //   console.log("Prefix clicked!");
                  //   setIsModalOpen(true);
                  // }}

                  // setIsModalOpen={setIsModalOpen}
                  // isModalOpen={isModalOpen}
                  // type="number"
                  placeholder="Phone Number"
                  name={"mobile"}
                  value={values.mobile}
                  handleBlur={handleBlur}
                  isShowSuffix={true}
                  suffix={<IoCallOutline className="icon-eye-v2" />}
                  showCountryFlagInPrefix={true}
                  selectedCountry={selectedCountry}
                  setSelectedCountry={setSelectedCountry}
                  isTouched={touched?.mobile}
                  error={errors?.mobile}
                  onChange={(e: any) => {
                    handleChange(e);
                  }}
                />
                /* <div style={{ marginTop: "3px" }}>
                    <ErrorMessageV2
                      message={
                        touched?.mobile && errors?.mobile
                          ? errors?.mobile ?? ""
                          : undefined
                      }
                      touched={touched?.mobile}
                    />
                  </div> */
                // </div>
              )}

              {config?.login?.termAndConditionCheckbox && (
                <div className="term-and-condition">
                  <CustomCheckbox
                    checked={termsChecked}
                    onChange={setTermsChecked}
                  />
                  <div>
                    I have read and accept the{" "}
                    <Link
                      href={AppRoutes.termAndCondition}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms & Conditions
                    </Link>{" "}
                    and{" "}
                    <Link
                      href={AppRoutes.privacyAndPolicy}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </Link>{" "}
                  </div>
                </div>
              )}

              <CustomButtonV2
                fullWidth
                disabled={
                  config?.login?.termAndConditionCheckbox
                    ? !isValid || !termsChecked
                    : !isValid
                }
                isLoading={isLoading}
                onClick={() => {
                  if (isValid && !isLoading) {
                    handleDivClick(submitForm);
                  }
                }}
                ref={buttonRef}
              >
                {t("linkMembership.continue")}
              </CustomButtonV2>
              {config?.login?.showauth && (
                <div className="display_desktop">
                  <Oauth setIsLoading={setIsLoading} />
                </div>
              )}
            </div>
          </div>
        )}

        {config?.login?.showauth && (
          <div className="display_mobile">
            <Oauth setIsLoading={setIsLoading} />
          </div>
        )}
      </div>
    </WebUI>

    // <WebUI>
    //   <div className="right-login-desktop-container">
    //     {isOTPComponent ? (
    //       <div className="form-screen-v2">
    //         <div className="back_button_prelogin black-only display_desktop">
    //           <button
    //             className="back-btn-v2 "
    //             onClick={() => {
    //               router.back();
    //             }}
    //           >
    //             <IoArrowBackSharp size={24} />
    //           </button>
    //         </div>
    //         {config?.preLoginCustomHeader?.isShowCustomHeader && (
    //           <PreLoginCustomHeader dark showLogo={false} />
    //         )}

    //         <OTPRegisterPageV2
    //           bearerToken={UniversalStorageUtils.getItem(
    //             config?.nativeDataSavingType,
    //             UniversalStorageConstants.AUTH_TOKEN
    //           )}
    //           loginSourceValue={
    //             switchSignInType == "mobile" ? values.mobile : values.email
    //           }
    //           countryCode={countryCode}
    //           editOnClick={() => {}}
    //           switchSignInType={
    //             switchSignInType == "mobile" ? "phone number" : "email address"
    //           }
    //         />
    //       </div>
    //     ) : (
    //       <div className="form-screen-v2">
    //         <div className="overlay-v2 display_mobile">
    //           <img
    //             src={getImagePath("v2/login/login_bg.png")}
    //             alt="Logo"
    //             className="bg-login-v2"
    //           />
    //         </div>
    //         <div className="back_button_prelogin display_desktop">
    //           <button
    //             className="back-btn-v2 "
    //             onClick={() => {
    //               if (isOTPComponent) {
    //                 UniversalStorageUtils.clear(config?.nativeDataSavingType);
    //                 setIsOTPComponent(false);
    //                 signUpForm.resetForm();
    //                 setIsLoading(false);
    //               } else {
    //                 router.push(AppRoutes.landing);
    //               }
    //             }}
    //           >
    //             <IoArrowBackSharp size={24} />
    //           </button>
    //         </div>
    //         <PreLoginCustomHeader />
    //         <div className="login-form-container">
    //           <LoginHeader style={{ textAlign: "start" }} />
    //           {LoginMethodSelector()}

    //           {switchSignInType == "email" && (
    //             <div className="email-username-container">
    //               <InputTextBoxV2
    //                 mainClassName={"custom-input-bordered"}
    //                 hint={placeHolderText}
    //                 onChange={(e: any) => {
    //                   handleChange(e);
    //                 }}
    //                 handleKeyDown={handleKeyDown}
    //                 isShowSuffix={true}
    //                 suffix={<MdOutlineEmail className="icon-eye-v2" />}
    //                 onBlur={handleBlur}
    //                 name="email"
    //                 maxLength={50}
    //                 value={values.email}
    //                 placeholder={"Email"}
    //                 hasError={touched?.email != null && errors?.email != null}
    //               />
    //               <div style={{ marginTop: "3px" }}>
    //                 <ErrorMessage
    //                   message={touched?.email ? errors?.email ?? "" : undefined}
    //                   touched={touched?.email}
    //                 />
    //               </div>
    //             </div>
    //           )}

    //           {switchSignInType == "mobile" && (
    //             <div>
    //               <MobileSelectNewV2
    //                 placeholder="Phone Number"
    //                 mainClassName="custom-input-bordered-mobile-blue"
    //                 handleChange={handleChange}
    //                 handleBlur={handleBlur}
    //                 formik={signUpForm}
    //                 countryCode={countryCode}
    //                 countryCodesArr={countriesData}
    //                 setCountryCode={setCountryCode}
    //                 setCountryCodeFlag={setCountryCodeflag}
    //                 setCountryCodeISO={setSelectedCountryISO}
    //                 handleKeyDown={handleKeyDown}
    //                 value={values.mobile}
    //                 name={"mobile"}
    //                 hasError={touched?.mobile != null && errors?.mobile != null}
    //                 prefix={
    //                   <div style={{ display: "flex", alignItems: "center" }}>
    //                     {selectedCountryISO && (
    //                       <Image
    //                         src={`https://flagcdn.com/w40/${selectedCountryISO}.png`}
    //                         width={25}
    //                         height={20}
    //                         alt=""
    //                       />
    //                     )}
    //                     <span className="flag" style={{ fontSize: "15px" }}>
    //                       {countryCode ?? ""}
    //                     </span>
    //                     <IoIosArrowDown />
    //                   </div>
    //                 }
    //                 isShowPrefix={true}
    //                 onPrefixClick={() => {
    //                   console.log("Prefix clicked!");
    //                   setIsModalOpen(true);
    //                 }}
    //                 isShowSuffix={true}
    //                 setIsModalOpen={setIsModalOpen}
    //                 isModalOpen={isModalOpen}
    //                 suffix={<IoCallOutline className="icon-eye-v2" />}
    //               />
    //               <div style={{ marginTop: "3px" }}>
    //                 <ErrorMessageV2
    //                   message={
    //                     touched?.mobile && errors?.mobile
    //                       ? errors?.mobile ?? ""
    //                       : undefined
    //                   }
    //                   touched={touched?.mobile}
    //                 />
    //               </div>
    //             </div>
    //           )}

    //           <CustomButtonV2
    //             fullWidth
    //             disabled={!isValid}
    //             isLoading={isLoading}
    //             onClick={() => {
    //               if (isValid && !isLoading) {
    //                 handleDivClick(submitForm);
    //               }
    //             }}
    //             ref={buttonRef}
    //           >
    //             Continue
    //           </CustomButtonV2>

    //           {config?.login?.showauth && (
    //             <div className="display_desktop">
    //               <Oauth setIsLoading={setIsLoading} />
    //             </div>
    //           )}
    //         </div>
    //       </div>
    //     )}

    //     {config?.login?.showauth && (
    //       <div className="display_mobile">
    //         <Oauth setIsLoading={setIsLoading} />
    //       </div>
    //     )}
    //   </div>
    // </WebUI>
  );
}

const LoginHeader = ({ style }: { style: React.CSSProperties }) => {
  const { t } = useTranslation();
  return (
    <div className="login-header-description-container" style={style}>
      <h2>{t("loginSignUp.welcomeBack")}</h2>
      <p>{t("loginSignUp.logInWithYour")}</p>
    </div>
  );
};

export default isLoggedIn(LoginWithOTPV2);
